// extracted by mini-css-extract-plugin
export default {"title":"yPtdx2Fup6Umejf64mP3lg==","list":"C1UH81Xte6RH08ZqqhVXzg==","list-item":"_7Y4XzjkciJmQyYfAsLxzuA==","image":"y2315fiv+PLByHPW2e10MA=="};